module.exports = __webpack_public_path__ + "media/sample-6s.b32530d4.mp3";